<div class="d-flex flex-nowrap">
  <div class="control" *ngIf="displayScrollButtons">
    <button
      *ngIf="canScrollPrev()"
      type="button"
      class="btn"
      (click)="scrollPrev()"
    >
      <div class="icon-bold-arrow-left"></div>
    </button>
  </div>
  <div class="flex-grow-1 overflow-hidden">
    <div class="tabs-container h-100" #scrollable>
      <ul class="tabs h-100" #tabList>
        <ng-container *ngFor="let tab of tabs; let i = index">
          <div class="tab-item">
            <button
              class="tab-button h-100"
              [ngClass]="{ active: i === active }"
              (click)="selectTab(i)"
            >
              {{ tab.name }}
            </button>
          </div>
        </ng-container>
      </ul>
    </div>
  </div>
  <div class="control" *ngIf="displayScrollButtons">
    <button
      *ngIf="canScrollNext()"
      type="button"
      class="btn"
      (click)="scrollNext()"
    >
      <div class="icon-bold-arrow-right"></div>
    </button>
  </div>
</div>
